module.exports = __webpack_public_path__ + "fonts/BarlowCondensed-ExtraLight.00ef54f.woff2";